/* eslint-disable import-x/no-default-export */
import Chance from 'chance';

const chance = new Chance();

const savedSearchDisplayQuery = () =>
  chance.pickset(
    [
      {
        type: 'salaryrange',
        value: ['$0k to $200k+'],
      },
      {
        type: 'worktype',
        value: ['Full time'],
      },
      {
        type: 'where',
        value: ['Melbourne CBD & Inner Suburbs Melbourne VIC'],
      },
      {
        type: 'classification',
        value: ['Information & Communication Technology'],
      },
      {
        type: 'subclassification',
        value: ['Testing & Quality Assurance'],
      },
      {
        type: 'keywords',
        value: chance.pickset(['"React JS"'], 1),
      },
    ],
    chance.natural({ min: 1, max: 5 }),
  );

chance.mixin({ savedSearchDisplayQuery });

const savedSearchQuery = ({ id }: { id: string }) => ({
  worktype: chance.pickone(['242']),
  classification: chance.pickone(['6281']),
  subclassification: chance.pickone(['6301']),
  where: chance.pickone(['Melbourne CBD & Inner Suburbs Melbourne VIC']),
  salarytype: chance.pickone(['annual']),
  salaryrange: chance.pickone(['0-999999']),
  keywords: chance.pickone(['React JS']),
  savedsearchid: id,
});

chance.mixin({ savedSearchQuery });

const savedSearch = () => {
  const id = chance.guid();
  // @ts-ignore - savedSearchDisplayQuery is mixin on chance
  const query = chance.savedSearchQuery({ id });
  return {
    id,
    name: chance.sentence({
      words: 5,
    }),
    modifiedDate: chance.date({
      string: true,
    }),
    query,
    // @ts-ignore - savedSearchDisplayQuery is mixin on chance
    displayQuery: chance.savedSearchDisplayQuery({
      query,
    }),
    allowNotification: chance.bool(),
    count: chance.natural({
      min: 0,
      max: 25,
    }),
  };
};

chance.mixin({
  savedSearch,
});

// @ts-ignore - savedSearch is mixin on chance

export default () => chance.savedSearch();
